import { render, staticRenderFns } from "./ChatContentExtension.vue?vue&type=template&id=5444eee2&scoped=true"
import script from "./ChatContentExtension.vue?vue&type=script&lang=js"
export * from "./ChatContentExtension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5444eee2",
  null
  
)

export default component.exports